import {
  IstitutionActionTypes,
  PortalActionTypes,
  ContactActionTypes,
  OrganizationTypes,
  ReminderTypes,
  ScheduleEmailReportTypes,
  OrganizationBranchesTypes
} from './types';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

const initialState = {
  imgCacheClearer: Date.now(),
  isSet: false,
  institutions: { data: [] },
  institutionInfo: {},
  portalSettings: {},
  savingPortalSettings: false,
  errorSavingPortalSettings: null,
  savingInstitutionInfo: false,
  errorSavingInstitutionInfo: null,
  savingContactInfo: false,
  errorSavingContactInfo: null,
  loading: false,
  error: {},
  status: null,
  currentPortal: null,
  isCheckingOrg: false,
  isCheckingOrgError: false,
  aliases: {
    course: 'job',
  },
  fetchingReminders: true,
  savingReminder: false,
  edittingReminder: false,
  deletingReminder: false,
  reminders: {
    data: [],
  },
  fetchingSchedule: true,
  schedule: {
    data: [],
  },
  deletingSchedule: false,
  edittingSchedule: false,

  // org branches
  fetchingOrgBranches: true,
  savingOrgBranch: false,
  edittingOrgBranch: false,
  deletingOrgBranch: false,
  orgBranches: {
    data: [],
  },
};

function configurationsReducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case IstitutionActionTypes.ADD_INSTITUTION:
      return {
        ...state,
        savingInstitutionInfo: true,
      };
    case PortalActionTypes.ADD_PORTAL:
      return {
        ...state,
        savingPortalSettings: true,
      };
    case PortalActionTypes.GET_PORTAL:
      return {
        ...state,
        loading: true,
      };
    case PortalActionTypes.GET_PORTAL_SUCCESS:
      return {
        ...state,
        portalSettings: payload,
        loading: false,
      };
    case IstitutionActionTypes.ADD_INSTITUTION_ALIAS_SUCCESS:
      return {
        ...state,
        aliases: {
          course:
            payload?.courseAlias ||
            state.institutionInfo?.courseAlias ||
            'course',
        },
        savingInstitutionInfo: false,
      };
    case IstitutionActionTypes.ADD_INSTITUTION_SUCCESS:
      return {
        ...state,
        institutionInfo: {
          ...state.institutionInfo,
          ...payload,
        },
        imgCacheClearer: Date.now(),
        savingInstitutionInfo: false,
      };
    case IstitutionActionTypes.GET_INSTITUTION_SUCCESS:
      return {
        ...state,
        aliases: {
          course:
            payload?.courseAlias ||
            state.institutionInfo?.courseAlias ||
            'course',
        },
        institutionInfo: {
          ...state.institutionInfo,
          ...payload,
        },
        isSet: true,
      };
    case PortalActionTypes.ADD_PORTAL_SUCCESS:
      return {
        ...state,
        portalSettings: {
          ...state.portalSettings,
          ...payload,
        },
        errorSavingPortalSettings: null,
        savingPortalSettings: false,
        savingContactInfo: false,
        errorSavingContactInfo: null,
      };
    case PortalActionTypes.ADD_PORTAL_FAILED:
      return {
        ...state,
        loading: false,
        error: payload,
        savingPortalSettings: false,
        savingContactInfo: false,
        imgCacheClearer: Date.now(),
      };
    case ContactActionTypes.SAVE_CONTACT:
      return {
        ...state,
        savingContactInfo: true,
      };
    case ContactActionTypes.SAVE_CONTACT_FAILED:
      return {
        ...state,
        savingContactInfo: false,
        errorSavingContactInfo: payload,
      };
    case IstitutionActionTypes.ADD_INSTITUTION_FAILED:
      return {
        ...state,
        savingInstitutionInfo: false,
        errorSavingInstitutionInfo: payload,
      };
    case PortalActionTypes.SET_CURRENT_SETTINGS:
      return {
        ...state,
        currentPortal: payload,
        loading: false,
      };
    case PortalActionTypes.CLEAR_CURRENT_SETTINGS:
      return {
        ...state,
        currentPortal: null,
      };
    case OrganizationTypes.CHECK_ORG_EXISTS:
      return {
        ...state,
        isCheckingOrg: true,
      };
    case OrganizationTypes.CHECK_ORG_EXISTS_SUCCESS:
      return {
        ...state,
        isCheckingOrg: false,
        isCheckingOrgError: false,
      };
    case OrganizationTypes.CHECK_ORG_EXISTS_FAILED:
      return {
        ...state,
        isCheckingOrg: false,
        isCheckingOrgError: true,
      };

    case ReminderTypes.FETCHING_REMINDER_SETTINGS:
      return {
        ...state,
        fetchingReminders: true,
      };
    case ReminderTypes.FETCHING_REMINDER_SETTINGS_SUCCESS:
      return {
        ...state,
        fetchingReminders: false,
        reminders: payload,
      };
    case ReminderTypes.FETCHING_REMINDER_SETTINGS_FAILED:
      return {
        ...state,
        fetchingReminders: false,
      };

    // saving reminder
    case ReminderTypes.SAVING_REMINDER_SETTINGS:
      return {
        ...state,
        savingReminder: true,
      };
    case ReminderTypes.SAVING_REMINDER_SETTINGS_SUCCESS:
      return {
        ...state,
        savingReminder: false,
        reminders: {
          ...state.reminders,
          data: [payload, ...state.reminders.data],
        },
      };
    case ReminderTypes.SAVING_REMINDER_SETTINGS_FAILED:
      return {
        ...state,
        savingReminder: false,
      };

    // editting reminder
    case ReminderTypes.EDITING_REMINDER_SETTINGS:
      return {
        ...state,
        edittingReminder: true,
      };
    case ReminderTypes.EDITING_REMINDER_SETTINGS_SUCCESS:
      return {
        ...state,
        edittingReminder: false,
        reminders: {
          ...state.reminders,
          data: state.reminders.data.map((reminder) =>
            reminder.id === payload.id ? { ...payload } : reminder
          ),
        },
      };
    case ReminderTypes.EDITING_REMINDER_SETTINGS_FAILED:
      return {
        ...state,
        edittingReminder: false,
      };

    // deleting reminder
    case ReminderTypes.DELETING_REMINDER_SETTINGS:
      return {
        ...state,
        deletingReminder: true,
      };
    case ReminderTypes.DELETING_REMINDER_SETTINGS_SUCCESS:
      return {
        ...state,
        deletingReminder: false,
        reminders: {
          ...state.reminders,
          data: state.reminders.data.filter(
            (reminder) => reminder.id !== payload
          ),
        },
      };
    case ReminderTypes.DELETING_REMINDER_SETTINGS_FAILED:
      return {
        ...state,
        deletingReminder: false,
      };

    // Email Report Schedule

    case ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS:
      return {
        ...state,
        fetchingSchedule: true,
      };
    case ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS_SUCCESS:
      return {
        ...state,
        fetchingSchedule: false,
        schedule: payload,
      };
    case ScheduleEmailReportTypes.FETCHING_EMAIL_SCHEDULE_SETTINGS_FAILED:
      return {
        ...state,
        fetchingSchedule: false,
      };

    // deleting Schedule Email Report

    case ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS:
      return {
        ...state,
        deletingSchedule: true,
      };
    case ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS_SUCCESS:
      return {
        ...state,
        deletingSchedule: false,
        schedule: {
          ...state.schedule,
          data: state.schedule.data.filter(
            (schedule) => schedule.id !== payload
          ),
        },
      };
    case ScheduleEmailReportTypes.DELETING_EMAIL_SCHEDULE_SETTINGS_FAILED:
      return {
        ...state,
        deletingSchedule: false,
      };

    // Editing Schedule Email Report

    case ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS:
      return {
        ...state,
        edittingSchedule: true,
      };
    case ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS_SUCCESS:
      return {
        ...state,
        edittingSchedule: false,
        schedule: {
          ...state.schedule,
          data: state.schedule.data.map((schedule) =>
            schedule.id === payload.id ? { ...payload } : schedule
          ),
        },
      };
    case ScheduleEmailReportTypes.EDITING_EMAIL_SCHEDULE_SETTINGS_FAILED:
      return {
        ...state,
        edittingSchedule: false,
      };


    // fetching org branches
    case OrganizationBranchesTypes.FETCHING_ORG_BRANCHES:
      return {
        ...state,
        fetchingOrgBranches: true,
      };
    case OrganizationBranchesTypes.FETCHING_ORG_BRANCHES_SUCCESS:
      return {
        ...state,
        fetchingOrgBranches: false,
        orgBranches: payload,
      };
    case OrganizationBranchesTypes.FETCHING_ORG_BRANCHES_FAILED:
      return {
        ...state,
        fetchingOrgBranches: false,
      };

    // saving org branches
    case OrganizationBranchesTypes.SAVING_ORG_BRANCH:
      return {
        ...state,
        savingOrgBranch: true,
      };
    case OrganizationBranchesTypes.SAVING_ORG_BRANCH_SUCCESS:
      return {
        ...state,
        savingOrgBranch: false,
        orgBranches: {
          ...state.orgBranches,
          data: [payload, ...state.orgBranches.data],
        },
      };
    case OrganizationBranchesTypes.SAVING_ORG_BRANCH_FAILED:
      return {
        ...state,
        savingOrgBranch: false,
      };

    // editting org branches
    case OrganizationBranchesTypes.EDITING_ORG_BRANCH:
      return {
        ...state,
        edittingOrgBranch: true,
      };
    case OrganizationBranchesTypes.EDITING_ORG_BRANCH_SUCCESS:
      return {
        ...state,
        edittingOrgBranch: false,
        orgBranches: {
          ...state.orgBranches,
          data: state.orgBranches.data.map((branch) =>
            branch.id === payload.id ? { ...payload } : branch
          ),
        },
      };
    case OrganizationBranchesTypes.EDITING_ORG_BRANCH_FAILED:
      return {
        ...state,
        edittingOrgBranch: false,
      };

    // deleting org branches
    case OrganizationBranchesTypes.DELETING_ORG_BRANCH:
      return {
        ...state,
        deletingOrgBranch: true,
      };
    case OrganizationBranchesTypes.DELETING_ORG_BRANCH_SUCCESS:
      return {
        ...state,
        deletingOrgBranch: false,
        orgBranches: {
          ...state.orgBranches,
          data: state.orgBranches.data.filter(
            (branch) => branch.id !== payload
          ),
        },
      };
    case OrganizationBranchesTypes.DELETING_ORG_BRANCH_FAILED:
      return {
        ...state,
        deletingOrgBranch: false,
      };

    default:
      return state;
  }
}

const persistConfig = {
  key: 'institutionInfo',
  storage,
  whitelist: ['institutionInfo'],
};

export default persistReducer(persistConfig, configurationsReducer);